import { createSlice } from '@reduxjs/toolkit';
import { IRawEvent } from '../../Types/DoyPrediction';
import { IEvent } from '../../Types/Event';
import { IResource } from '../../Types/Resource';
import { IPredictionsState } from '../actions/predictions.actions';
import { fetchAllPredictions } from '../middlewares/predictions.middleware';

const initialState: IPredictionsState  = {
  resources: [],
  events: [],
  raw: [],
  loading: false,
  error: null,
}

const predictionsSlice = createSlice({
  name: 'predictions',
  initialState: initialState,
  reducers: {
    loadingStart(state) {
      state.loading = true;
    },
    loadingFinished(state) {
      state.loading = false;
    },
    replacePredictions(state, action) {
      const events: IEvent[] = action.payload;
      state.events = events;
    },
    addPrediction(state, action) {
      const event: IEvent = action.payload;
      state.events = [ ...(state.events.filter((e) => e.id !== event.id)), event]
    },
    removePrediction(state, action) {
      const event: IEvent = action.payload;
      state.events = state.events.filter((e) => e.id !== event.id);
    },
    replaceResources(state, action) {
      const resources: IResource[] = action.payload;
      state.resources = resources;
    },
    addResource(state, action) {
      const resource: IResource = action.payload;
      state.resources = [ ...(state.resources.filter((r) => r.id !== resource.id)), resource ]
    },
    removeResource(state, action) {
      const resource: IResource = action.payload;
      state.resources = state.resources.filter((r) => r.id !== resource.id);
    },
    replaceRawData(state, action) {
      const raw: IRawEvent[] = action.payload;
      state.raw = raw;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllPredictions.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchAllPredictions.fulfilled, (state, { payload }) => {
      state.events = payload;
      state.loading = false;
    });
    builder.addCase(fetchAllPredictions.rejected, (state, { payload }) => {
      state.loading = false;
      if (payload) { // ???
        state.error = "error loading"; // TODO: Translations
      }
    });
  },
});

export default predictionsSlice;
export const predictionsReducer = predictionsSlice.reducer;
